import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.speciality-hero',
        videoRoot: '.speciality-hero__video',
        video: '.video-js',
        playPauseBtn: '.speciality-hero__play-pause-btn',
        playPauseBtnIcon: '.speciality-hero__play-pause-btn-icon',
        videoWrapper: '.speciality-hero__video-wrapper',
        imageWrapper: '.speciality-hero__visual',
        videoTextblock: '.speciality-hero__textblock'
    },
    classNames: {
        playIcon: 'speciality-hero__play-pause-btn-icon--play',
        pauseIcon: 'speciality-hero__play-pause-btn-icon--pause',
        hiddenControls: 'speciality-hero__textblock--hidden-control',
        scroll: 'speciality-hero--scroll',
        hasScrolled: 'speciality-hero--has-scrolled'
    },
    dataAttributes: {
        autoplay: 'autoplay',
        videoId: 'video-id',
        mobileVideoId: 'mobile-video-id',
    },
    pauseIconCircle: '<img src="assets/icons/pauseCircle.svg" width="24px" height="24px" alt="Play / Pause">',
    pauseIconCircleWhite: '<img src="assets/icons/pauseCircleWhite.svg" width="24px" height="24px" alt="Play / Pause">',
    playIconPaths: '<span class="path1"></span><span class="path2"></span>',
};

class SpecialityHero {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._videoVisible = false;
        this._width = '';
    }

    init() {
        this._elements = this._getDomElements();

        if(this._elements.$video.length === 0) {
           this._elements.$playPauseBtn.hide(); 
        }

        this._addEventListeners();
        this._screenClick();
        this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
        this._autoPlayVideo();
        this._hidePlayPauseBtn();
    }

    _getDomElements() {
        return {
            $videoRoot: this._$rootElement.find(config.selectors.videoRoot),
            $video: this._$rootElement.find(config.selectors.video),
            $playPauseBtn: this._$rootElement.find(config.selectors.playPauseBtn),
            $playPauseBtnIcon: this._$rootElement.find(config.selectors.playPauseBtnIcon),
            $videoWrapper: this._$rootElement.find(config.selectors.videoWrapper),
            $imageWrapper: this._$rootElement.find(config.selectors.imageWrapper),
        };
    }

    _addEventListeners() {
        const _this = this;
        
        this._elements.$playPauseBtn.on('click', () => {
            for(const videoSettings of this._elements.$video) {
                this._playPauseHandler(videoSettings);
            } 
        });

        // only show video if it can be played, else stay on image
        for(const videoSettings of this._elements.$video) {
            if(videoSettings && videoSettings.player) {
                videoSettings.player.on("play", function () {
                    if(!_this._videoVisible) {
                        _this._elements.$imageWrapper.hide();
                        _this._elements.$videoWrapper.show();
                        _this._videoVisible = true;
                    }
                });
            }
        } 
        
        if(this._$rootElement.hasClass(config.classNames.scroll)) {
            window.addEventListener('scroll', () => {
                if(Breakpoints.isBreakpointOrLarger('lg')) {
                    _this._setWidth();
                }
            });
        }

        Breakpoints.onBreakpointChange(() => {
            if(Breakpoints.isBreakpointOrLarger('lg')) {
                _this._setWidth();
            } else {
                this._$rootElement.css('maxWidth', '100%');
                this._$rootElement.removeClass(config.classNames.hasScrolled);
            }
        })
    }

    _setWidth() {
        const top = window.scrollY;
        const elementTop = this._$rootElement.position().top;


        if(top !== 0) {
            this._$rootElement.addClass(config.classNames.hasScrolled);
        }

        const max = 400;
        const minMaxWidth = 1270;

        // harmonize width
        const widthDifference = window.innerWidth - minMaxWidth;
        const multiplicator = 1 - ((max - top) / max);
        const value = window.innerWidth - (widthDifference * multiplicator);
        const finalValue = value < 1270 ? 1270 : value;

        if(!this._width || this._width > finalValue) {
            this._width = finalValue;

            this._$rootElement.css('maxWidth', finalValue + 'px');
        }
        
    }

    // eslint-disable-next-line class-methods-use-this
    _autoPlayVideo() {
        
        if (this._elements.$video.data(config.dataAttributes.autoplay)) {
            for(const videoSettings of this._elements.$video) {
                this._muteVideo(videoSettings);
                this._playPauseHandler(videoSettings);
                videoSettings.player.on("ended", function () {
                    //loop if video ended
                    videoSettings.player.play();
                });
            }
            
        }
    }

    _muteVideo(videoSettings) {
        videoSettings.player.muted(true);
    }

    _playPauseHandler(videoSettings) {
        if (videoSettings.player.paused()) {
            videoSettings.player.play();

            this._elements.$playPauseBtnIcon.removeClass(config.classNames.playIcon);
            this._elements.$playPauseBtnIcon.addClass(config.classNames.pauseIcon);
        } else {
            videoSettings.player.pause();
            this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
            this._elements.$playPauseBtnIcon.removeClass(config.classNames.pauseIcon);
        }
    }

    _screenClick() {
        const videoSettings = this._elements.$video[0];

        this._elements.$video.on('click', (e) => {
            e.preventDefault();
            if (videoSettings.player.paused()) {
                videoSettings.player.play();

                this._elements.$playPauseBtnIcon.removeClass(config.classNames.playIcon);
                this._elements.$playPauseBtnIcon.addClass(config.classNames.pauseIcon);
            } else {
                videoSettings.player.pause();
                this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
                this._elements.$playPauseBtnIcon.removeClass(config.classNames.pauseIcon);
            }
        });
    }

    _hidePlayPauseBtn() {
        // dont hide play pause button for hero section (modifier --scroll)
        if(this._$rootElement.hasClass(config.classNames.scroll)) return;

        const videoElements = $(this._elements.$video)
        for (let index = 0; index < videoElements.length; index++) {
            const videoElement = videoElements[index];
          
             if($(videoElement).data(config.dataAttributes.autoplay)) {
                $(videoElement).closest(config.selectors.root).find(config.selectors.videoTextblock).addClass(config.classNames.hiddenControls)
            }else {
                $(videoElement).closest(config.selectors.root).find(config.selectors.videoTextblock).removeClass(config.classNames.hiddenControls)
            }
        }
    }
}

moduleRegistry.registerModule('SpecialityHero', SpecialityHero);
moduleRegistry.autoApplyModule('SpecialityHero', config.selectors.root);
